export const URLS = {
 //BACKEND: 'https://productselector.de'
 BACKEND: 'https://connect-dev.productselector.de' 
 //BACKEND: 'http://10.211.55.3:3011'
  };
